<div class="row g-1">
	<div class="col-12">
		<div class="row g-1 mb-0">
			<div class="col-12">
				<div class="card mb-0">
					<div class="card-body p-1">
						<div class="row g-1">
							<div class="col-3">
								<div class="input-group input-group-sm">
									<label class="input-group-text" for="filters3_start_year">From</label>
									<select class="form-select" [(ngModel)]="filters3.start_year"
										(change)="getSnapshotData1()" id="filters3_start_year">
										@for (item of yearList; track $index) {
										<option [value]="item.value">
											{{item.name}}
										</option>
										}
									</select>
									<select class="form-select" [(ngModel)]="filters3.start_month"
										(change)="getSnapshotData1()">
										@for (item of monthList; track $index) {
										<option [value]="item.value">
											{{item.name}}
										</option>
										}
									</select>
								</div>
							</div>
							<div class="col-3">
								<div class="input-group input-group-sm">
									<label class="input-group-text" for="filters3_end_year">To</label>
									<select class="form-select" [(ngModel)]="filters3.end_year"
										(change)="getSnapshotData1()" id="filters3_end_year">
										@for (item of yearList; track $index) {
										<option [value]="item.value">
											{{item.name}}
										</option>
										}
									</select>
									<select class="form-select" [(ngModel)]="filters3.end_month"
										(change)="getSnapshotData1()">
										@for (item of monthList; track $index) {
										<option [value]="item.value">
											{{item.name}}
										</option>
										}
									</select>
								</div>
							</div>
							<div class="col-2">
								@if(loader1){
								<app-spinner></app-spinner>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row g-1">
			@for (category of fieldset; track category.category) {
			<div class="col-4">
				<div class="card mb-2">
					<div class="card-header mb-0" [ngClass]="category.bg">
						<h5 class="card-title text-light text-center mb-0">
							{{category.category}}
						</h5>
					</div>
					<div class="card-body p-1">
						<div class="row g-1">
							<div class="col-12">
								<table class="table table-bordered table-hover card-table">
									<tbody>
										@for (item of category.snapshot_fields; track item.key) {
										<tr>
											<td>
												<h5 class="snapshot-data">
													<label role="button">
														<input class="form-check-input" type="radio"
															name="filters5_flag" [value]="item.key"
															[(ngModel)]="filters5.flag" (change)="refreshTable()">
														{{item.label}}
													</label>
													<strong>
														@if(snapshotData1){
														{{snapshotData1[item.key]}}
														}@else{
														___
														}
													</strong>
												</h5>
											</td>
										</tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			}
		</div>
	</div>
	<!-- <div class="col-5">
		<div class="row g-1 mb-0">
			<div class="col-12">
				<div class="card mb-0">
					<div class="card-body p-1">
						<div class="row g-1">
							<div class="col-5">
								<div class="input-group input-group-sm">
									<label class="input-group-text" for="filters4_start_month">Month</label>
									<select class="form-select" [(ngModel)]="filters4.start_month"
										(change)="getSnapshotData2()" id="filters4_start_month">
										@for (item of monthList; track $index) {
										<option [value]="item.value">
											{{item.name}}
										</option>
										}
									</select>
								</div>
							</div>
							<div class="col-1">
								@if(loader2){
								<app-spinner></app-spinner>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row g-1">
			@for (category of fieldset; track category.category) {
			<div class="col-4">
				<div class="card mb-2">
					<div class="card-header mb-0" [ngClass]="category.bg">
						<h5 class="card-title text-light text-center mb-0">
							{{category.category}}
						</h5>
					</div>
					<div class="card-body p-1">
						<div class="row g-1">
							<div class="col-12">
								<table class="table table-bordered table-hover card-table">
									<tbody>
										@for (item of category.monthly_fields; track item.key) {
										<tr>
											<td>
												<h5 class="snapshot-data">
													<label role="button">
														<input class="form-check-input" type="radio"
															name="filters5_flag" [value]="item.key"
															[(ngModel)]="filters5.flag" (change)="refreshTable()">
														{{item.label}}
													</label>
													<strong>
														@if(snapshotData2){
														{{snapshotData2[item.key]}}
														}@else{
														___
														}
													</strong>
												</h5>
											</td>
										</tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			}
		</div>
	</div> -->
</div>
<div class="row g-0">
	<div class="col">
		<div class="card">
			<div class="card-body p-1">
				<h4 class="mb-0 ps-1 fw-bold">{{getHeading()}}</h4>
				<div class="table-responsive mt--32">
					@if(dtOptions.pagingType){
					<table datatable [dtOptions]="dtOptions"
						class="table table-striped table-bordered table-hover appt-table"
						style="width: 100%;border: 1px solid rgb(187, 187, 187);">
						<thead>
							<tr class="table_head">
								<th style="width: 7%;">Case ID</th>
								<th style="width: 10%;">Vessel</th>
								<th style="width: 15%;">Crew Name</th>
								<th style="width: 8%;">Rank</th>
								<th style="width: 8%;">Arrival Date</th>
								<th style="width: 8%;">Fitness Date</th>
								<th style="width: 6%;">Days to Recover</th>
								<th style="width: 5%;" class="text-center">Case Status</th>
								<th style="width: 6%;">Case Category</th>
								<th style="width: 7%;">Closed Date</th>
								<th style="width: 10%;">Diagnosis</th>
								<th style="width: 10%;">Was Crew Hospitalised</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{v.case_id}}</td>
								<td>{{ v.vessel?.vessel_name }}</td>
								<td>{{ v.candidate.f_name }} {{ v.candidate.l_name }}</td>
								<td>{{ v.rank?.rank }}</td>
								<td>{{ v.arrival_date }}</td>
								<td>{{ v.fitness_date }}</td>
								<td>{{ v.case_days_by_fitness_date }}</td>
								<td class="text-center">
									<fa-icon [icon]="['fas',v.status_id==2?'lock':'lock-open']"
										matTooltip="{{ v.status_name }}"></fa-icon>
								</td>
								<td>{{ v.case_category?.name }}</td>
								<td>{{ v.close_date }}</td>
								<td>{{ v.diagnosis }}</td>
								<td>
									@if(v.other_details?.hospitalization_status){
										Yes
									}
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="12" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
					}
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row g-1 mb-0">
	<div class="col-12">
		<div class="card mb-1">
			<div class="card-header bg-illness mb-0">
				<h5 class="card-title text-light text-center mb-0">
					Open / Close cases by month
				</h5>
			</div>
			<div class="card-body p-1">
				<div class="row g-1">
					<div class="col-2">
						<div class="input-group input-group-sm">
							<label class="input-group-text" for="filters1_year">Year</label>
							<select class="form-select form-select-sm" [(ngModel)]="filters1.year"
								(change)="getCategoryChart()" id="filters1_year">
								@for (item of yearList; track $index) {
								<option [value]="item.value">
									{{item.name}}
								</option>
								}
							</select>
						</div>
					</div>
					<div class="col-1">
						@if(loader12){
						<app-spinner></app-spinner>
						}
					</div>
				</div>
				<div class="row g-1">
					<div class="col">
						<canvas baseChart [data]="catChartData" [options]="barChartOptions" chartType="bar">
						</canvas>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<mat-accordion [hideToggle]="false">
	<mat-expansion-panel [expanded]="false">
		<mat-expansion-panel-header class="bg-secondary" [collapsedHeight]="'35px'" [expandedHeight]="'40px'">
			<mat-panel-title>
				<strong class="text-white">
					<!-- <fa-icon [icon]="['fas','filter']"></fa-icon> -->
					Advanced Options
				</strong>
			</mat-panel-title>
			<mat-panel-description>
			</mat-panel-description>
		</mat-expansion-panel-header>
		<div>
			<div class="row g-1">
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-illness mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Illness Cases &gt; 90 Days
								<span class="float-end badge fw-bold bg-light text-dark">
									{{illnessAppts.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader3 && illnessAppts.length">
								<thead>
									<tr>
										<th style="width: 50%;">Name</th>
										<th style="width: 25%;">Case Id</th>
										<th style="width: 20%;">Open Days</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of illnessAppts;">
										<td>{{data.full_name}}</td>
										<td>
											{{data.case_id}}
										</td>
										<td>{{data.date_diff_days}}</td>
										<td>
											<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader3 && !illnessAppts.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader3">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-injury mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Injury Cases &gt; 180 Days
								<span class="float-end badge fw-bold bg-light text-dark">
									{{injuryAppts.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader10 && injuryAppts.length">
								<thead>
									<tr>
										<th style="width: 50%;">Name</th>
										<th style="width: 25%;">Case Id</th>
										<th style="width: 20%;">Open Days</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of injuryAppts;">
										<td>{{data.full_name}}</td>
										<td>
											{{data.case_id}}
										</td>
										<td>{{data.date_diff_days}}</td>
										<td>
											<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader10 && !injuryAppts.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader10">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-disability mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Potential Disability
								<span class="float-end badge fw-bold bg-light text-dark">
									{{disabilityAppts.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader5 && disabilityAppts.length">
								<thead>
									<tr>
										<th style="width: 55%;">Name</th>
										<th style="width: 20%;">Case Id</th>
										<th style="width: 20%;" class="text-end pe-2">Status</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of disabilityAppts;">
										<td>
											{{data.full_name}}
										</td>
										<td>
											{{data.case_id}}
										</td>
										<td class="text-end pe-2">
											<ng-container
												*ngIf="data.disability_per!=null && data.disability_per!='';else elsePer">
												{{data.disability_per}}%
											</ng-container>
											<ng-template #elsePer>-</ng-template>
										</td>
										<td>
											<fa-icon [icon]="['fas','info']"
												matTooltip="{{data.disability_date}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader5 && !disabilityAppts.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader5">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-hosp_surg mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Hospital / Surgery
								<span class="float-end badge fw-bold bg-light text-dark">
									{{hospSurgAppts.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader4 && hospSurgAppts.length">
								<thead>
									<tr>
										<th style="width: 50%;">Name</th>
										<th style="width: 25%;">Case Id</th>
										<th style="width: 20%;">Status</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of hospSurgAppts;">
										<td>{{data.full_name}}</td>
										<td>
											{{data.case_id}}
										</td>
										<td>{{data.hos_sur}}</td>
										<td>
											<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader4 && !hospSurgAppts.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader4">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="card mb-0">
						<div class="card-body p-1">
							<div class="row g-1">
								<div class="col-4 d-flex">
									<div class="input-group input-group-sm me-1">
										<span class="input-group-text">From</span>
										<input class="form-control" [(ngModel)]="filters2.start_date" ngbDatepicker
											#filters1_start_date="ngbDatepicker" [minDate]="minDate"
											[container]="'body'" />
										<button class="btn btn-outline-secondary" (click)="filters1_start_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<div class="input-group input-group-sm ms-1">
										<span class="input-group-text">To</span>
										<input class="form-control" placeholder="" [(ngModel)]="filters2.end_date"
											ngbDatepicker #filters1_end_date="ngbDatepicker" [minDate]="minDate"
											[container]="'body'" />
										<button class="btn btn-outline-secondary" (click)="filters1_end_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
								</div>
								<div class="col-2">
									<button type="button" class="btn btn-sm btn-success"
										(click)="getNewClosedData()" [disabled]="loader16 || loader17">
										@if(loader16 || loader17){
										<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
										}@else{
										<fa-icon [icon]="['fas','search']"></fa-icon>
										}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row g-1">
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-new mb-0">
							<h5 class="card-title text-light text-center mb-0">
								New cases registered within the current month
								<span class="float-end badge fw-bold bg-light text-dark">
									{{case_list_by_flag_new.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader16 && case_list_by_flag_new.length">
								<thead>
									<tr>
										<th style="width: 40%;">Name</th>
										<th style="width: 25%;">Case Id</th>
										<th style="width: 30%;">Start Date</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of case_list_by_flag_new;">
										<td>{{data.full_name}}</td>
										<td>
											{{data.case_id}}
										</td>
										<td>{{data.start_date}}</td>
										<td>
											<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader16 && !case_list_by_flag_new.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader16">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-closed mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Cases closed within this month
								<span class="float-end badge fw-bold bg-light text-dark">
									{{case_list_by_flag_closed.length}}
								</span>
							</h5>
						</div>
						<div class="card-body p-1 overflow-y-auto">
							<table class="table table-bordered table-hover card-table"
								*ngIf="!loader17 && case_list_by_flag_closed.length">
								<thead>
									<tr>
										<th style="width: 40%;">Name</th>
										<th style="width: 25%;">Case Id</th>
										<th style="width: 30%;">Closed Date</th>
										<th style="width: 5%;">
											<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let data of case_list_by_flag_closed;">
										<td>{{data.full_name}}</td>
										<td>
											{{data.case_id}}
										</td>
										<td>{{data.close_date}}</td>
										<td>
											<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="mb-0 text-center" *ngIf="!loader17 && !case_list_by_flag_closed.length">
								No appointments
							</p>
							<p class="mb-0 text-center" *ngIf="loader17">
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								Loading...
							</p>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-lt-31 mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Number of cases closed within 31 days
							</h5>
						</div>
						<div class="card-body p-1">
							<div class="row g-1">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="card overflow-x-hidden card-height-2">
										<div class="card-header bg-lt-31 mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Illness
												<span class="float-end badge fw-bold bg-light text-dark">
													{{case_list_by_flag_ill_lt_31.length}}
												</span>
											</h5>
										</div>
										<div class="card-body p-1 overflow-y-auto">
											<table class="table table-bordered table-hover card-table"
												*ngIf="!loader18 && case_list_by_flag_ill_lt_31.length">
												<thead>
													<tr>
														<th style="width: 40%;">Name</th>
														<th style="width: 25%;">Case Id</th>
														<th style="width: 30%;">Closed Date</th>
														<th style="width: 5%;">
															<fa-icon [icon]="['fas','info']"
																matTooltip="Updated at"></fa-icon>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let data of case_list_by_flag_ill_lt_31;">
														<td>{{data.full_name}}</td>
														<td>
															{{data.case_id}}
														</td>
														<td>{{data.close_date}}</td>
														<td>
															<fa-icon [icon]="['fas','info']"
																matTooltip="{{data.updated}}"></fa-icon>
														</td>
													</tr>
												</tbody>
											</table>
											<p class="mb-0 text-center"
												*ngIf="!loader18 && !case_list_by_flag_ill_lt_31.length">
												No appointments
											</p>
											<p class="mb-0 text-center" *ngIf="loader18">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading...
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="card overflow-x-hidden card-height-2">
										<div class="card-header bg-lt-31 mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Injury
												<span class="float-end badge fw-bold bg-light text-dark">
													{{case_list_by_flag_inj_lt_31.length}}
												</span>
											</h5>
										</div>
										<div class="card-body p-1 overflow-y-auto">
											<table class="table table-bordered table-hover card-table"
												*ngIf="!loader19 && case_list_by_flag_inj_lt_31.length">
												<thead>
													<tr>
														<th style="width: 40%;">Name</th>
														<th style="width: 25%;">Case Id</th>
														<th style="width: 30%;">Closed Date</th>
														<th style="width: 5%;">
															<fa-icon [icon]="['fas','info']"
																matTooltip="Updated at"></fa-icon>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let data of case_list_by_flag_inj_lt_31;">
														<td>{{data.full_name}}</td>
														<td>
															{{data.case_id}}
														</td>
														<td>{{data.close_date}}</td>
														<td>
															<fa-icon [icon]="['fas','info']"
																matTooltip="{{data.updated}}"></fa-icon>
														</td>
													</tr>
												</tbody>
											</table>
											<p class="mb-0 text-center"
												*ngIf="!loader19 && !case_list_by_flag_inj_lt_31.length">
												No appointments
											</p>
											<p class="mb-0 text-center" *ngIf="loader19">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading...
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
					<div class="card overflow-x-hidden card-height-1">
						<div class="card-header bg-gt-31 mb-0">
							<h5 class="card-title text-light text-center mb-0">
								Cases that are open more than 31 days
							</h5>
						</div>
						<div class="card-body p-1">
							<div class="row g-1">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="card overflow-x-hidden card-height-2">
										<div class="card-header bg-gt-31 mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Illness
												<span class="float-end badge fw-bold bg-light text-dark">
													{{case_list_by_flag_ill_gt_31.length}}
												</span>
											</h5>
										</div>
										<div class="card-body p-1 overflow-y-auto">
											<table class="table table-bordered table-hover card-table"
												*ngIf="!loader20 && case_list_by_flag_ill_gt_31.length">
												<thead>
													<tr>
														<th style="width: 40%;">Name</th>
														<th style="width: 25%;">Case Id</th>
														<th style="width: 30%;">Start Date</th>
														<th style="width: 5%;">
															<fa-icon [icon]="['fas','info']"
																matTooltip="Updated at"></fa-icon>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let data of case_list_by_flag_ill_gt_31;">
														<td>{{data.full_name}}</td>
														<td>
															{{data.case_id}}
														</td>
														<td>{{data.start_date}}</td>
														<td>
															<fa-icon [icon]="['fas','info']"
																matTooltip="{{data.updated}}"></fa-icon>
														</td>
													</tr>
												</tbody>
											</table>
											<p class="mb-0 text-center"
												*ngIf="!loader20 && !case_list_by_flag_ill_gt_31.length">
												No appointments
											</p>
											<p class="mb-0 text-center" *ngIf="loader20">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading...
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="card overflow-x-hidden card-height-2">
										<div class="card-header bg-gt-31 mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Injury
												<span class="float-end badge fw-bold bg-light text-dark">
													{{case_list_by_flag_inj_gt_31.length}}
												</span>
											</h5>
										</div>
										<div class="card-body p-1 overflow-y-auto">
											<table class="table table-bordered table-hover card-table"
												*ngIf="!loader21 && case_list_by_flag_inj_gt_31.length">
												<thead>
													<tr>
														<th style="width: 40%;">Name</th>
														<th style="width: 25%;">Case Id</th>
														<th style="width: 30%;">Start Date</th>
														<th style="width: 5%;">
															<fa-icon [icon]="['fas','info']"
																matTooltip="Updated at"></fa-icon>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let data of case_list_by_flag_inj_gt_31;">
														<td>{{data.full_name}}</td>
														<td>
															{{data.case_id}}
														</td>
														<td>{{data.start_date}}</td>
														<td>
															<fa-icon [icon]="['fas','info']"
																matTooltip="{{data.updated}}"></fa-icon>
														</td>
													</tr>
												</tbody>
											</table>
											<p class="mb-0 text-center"
												*ngIf="!loader21 && !case_list_by_flag_inj_gt_31.length">
												No appointments
											</p>
											<p class="mb-0 text-center" *ngIf="loader21">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading...
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="card mb-0">
						<div class="card-body p-1">
							<div class="row g-1">
								<div class="col-4 d-flex">
									<div class="input-group input-group-sm me-1">
										<span class="input-group-text">From</span>
										<input class="form-control" placeholder="" [(ngModel)]="filters1.start_date"
											ngbDatepicker #filters_start_date="ngbDatepicker" [minDate]="minDate"
											[container]="'body'" />
										<button class="btn btn-outline-secondary" (click)="filters_start_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<div class="input-group input-group-sm ms-1">
										<span class="input-group-text">To</span>
										<input class="form-control" placeholder="" [(ngModel)]="filters1.end_date"
											ngbDatepicker #filters_end_date="ngbDatepicker" [minDate]="minDate"
											[container]="'body'" />
										<button class="btn btn-outline-secondary" (click)="filters_end_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
								</div>
								<div class="col-2">
									<button type="button" class="btn btn-sm btn-success"
										(click)="getDateWiseData()" [disabled]="loader13 || loader14 || loader15">
										@if(loader13 || loader14 || loader15){
										<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
										}@else{
										<fa-icon [icon]="['fas','search']"></fa-icon>
										}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<div class="card">
						<div class="card-body p-1">
							<div class="row g-0">
								<div class="col-6">
									<div class="card">
										<div class="card-header bg-illness mb-0">
											<h5 class="card-title text-light text-center mb-0">
												ICD code wise Illness
											</h5>
										</div>
										<div class="card-body pie-container">
											@if(!loader13){
											@if(icd_code_data_illness.length){
											<ngx-charts-pie-chart [results]="icd_code_data_illness"
												[legend]="showPieChartLegend" [legendPosition]="legendPosition"
												[legendTitle]="''" [doughnut]="isDoughnut" [labels]="showPieChartLabels"
												[arcWidth]="arcWidth" [gradient]="gradient" [scheme]="colorScheme1">
												<ng-template #tooltipTemplate let-model="model">
													<h4 class="my-0">{{model.name}}</h4>
													<h5 class="my-0">{{model.value}}</h5>
												</ng-template>
											</ngx-charts-pie-chart>
											}@else {
											<h5 class="text-center">No data found</h5>
											}
											}@else{
											<app-spinner></app-spinner>
											}
										</div>
									</div>
								</div>
								<div class="col-6">
									<div class="card">
										<div class="card-header bg-illness mb-0">
											<h5 class="card-title text-light text-center mb-0">
												ICD code wise Injury
											</h5>
										</div>
										<div class="card-body pie-container">
											@if(!loader13){
											@if(icd_code_data_injury.length){
											<ngx-charts-pie-chart [results]="icd_code_data_injury"
												[legend]="showPieChartLegend" [legendPosition]="legendPosition"
												[legendTitle]="''" [doughnut]="isDoughnut" [labels]="showPieChartLabels"
												[arcWidth]="arcWidth" [gradient]="gradient" [scheme]="colorScheme2">
												<ng-template #tooltipTemplate let-model="model">
													<h4 class="my-0">{{model.name}}</h4>
													<h5 class="my-0">{{model.value}}</h5>
												</ng-template>
											</ngx-charts-pie-chart>
											}@else {
											<h5 class="text-center">No data found</h5>
											}
											}@else{
											<app-spinner></app-spinner>
											}
										</div>
									</div>
								</div>
							</div>
							<div class="row g-0">
								<div class="col-6">
									<div class="card">
										<div class="card-header bg-illness mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Billed/Unbilled
											</h5>
										</div>
										<div class="card-body">
											<div class="row">
												<div class="col text-center">
													<div class="card p-1 data-card text-light bg-theme">
														<p class="data-card-value fw-bold">
															@if(loader14){
															<fa-icon [icon]="['fas','spinner']"
																[animation]="'spin'"></fa-icon>
															}@else{
															{{ billed_unbilled_count.total_cases }}
															}
														</p>
														<p class="data-card-label">
															Total
														</p>
													</div>
												</div>
												<div class="col text-center">
													<div class="card p-1 data-card text-light bg-theme">
														<p class="data-card-value fw-bold">
															@if(loader14){
															<fa-icon [icon]="['fas','spinner']"
																[animation]="'spin'"></fa-icon>
															}@else{
															{{ billed_unbilled_count.billed_cnt }}
															}
														</p>
														<p class="data-card-label">
															Billed
														</p>
													</div>
												</div>
												<div class="col text-center">
													<div class="card p-1 data-card text-light bg-theme">
														<p class="data-card-value fw-bold">
															@if(loader14){
															<fa-icon [icon]="['fas','spinner']"
																[animation]="'spin'"></fa-icon>
															}@else{
															{{ billed_unbilled_count.unbilled_cnt }}
															}
														</p>
														<p class="data-card-label">
															Unbilled
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-6">
									<div class="card">
										<div class="card-header bg-illness mb-0">
											<h5 class="card-title text-light text-center mb-0">
												Other vs Hospitalized/Surgery
											</h5>
										</div>
										<div class="card-body pie-container">
											@if(!loader15){
											@if(hospitalized_data.length){
											<ngx-charts-pie-chart [results]="hospitalized_data"
												[legend]="showPieChartLegend" [legendPosition]="legendPosition"
												[legendTitle]="''" [doughnut]="isDoughnut" [labels]="showPieChartLabels"
												[arcWidth]="arcWidth" [gradient]="gradient" [scheme]="colorScheme3">
												<ng-template #tooltipTemplate let-model="model">
													<h4 class="my-0">{{model.name}}</h4>
													<h5 class="my-0">{{model.value}}</h5>
												</ng-template>
											</ngx-charts-pie-chart>
											}@else {
											<h5 class="text-center">No data found</h5>
											}
											}@else {
											<app-spinner></app-spinner>
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-expansion-panel>
</mat-accordion>